<script src="app/store/modules/currency.js"></script>
<template>
  <div id="app">
    <v-app>
      <sidenav v-model="showNav" />
      <toolbar
        id="app-top-nav"
        @toggleNav="showNav = !showNav"
      />
      <app-content
        id="app-content"
      />
      <v-footer
        id="footer"
        height="auto"
      >
        <v-layout
          justify-center
          row
          wrap
          :style="{marginLeft: getFooterMarginLeft()}"
        >
          <v-btn
            v-for="link in links"
            :key="link.name"
            :href="link.link.toString()"
            color="black"
            flat
            round
          >
            <strong class="footer-title">
              {{ link.name }}
            </strong>
          </v-btn>
          <v-flex
            py-3
            text-xs-center
            xs12
          >
            <strong>© 2026 The Pinkfong Company. All Rights Reserved.</strong>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import SideNav from 'app/SideNav.vue'
import Toolbar from 'app/Toolbar.vue'
import Content from 'app/Content.vue'

export default {
  components: {
    'sidenav': SideNav,
    'toolbar': Toolbar,
    'app-content': Content
  },
//   head: {
//     meta: function () {
//       return this.getMetaList
//     },
//     script: [
//       { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=G-X5VXFJ8LTH', async: true }, // Insert in body
//       { i: `window.dataLayer = window.dataLayer || [];
// function gtag(){dataLayer.push(arguments);}
// gtag('js', new Date());
// gtag('config', 'G-X5VXFJ8LTH');` }
//     ],
//   },
  metaInfo () {
    return {
      meta: this.getMetaList
    }
  },
  data () {
    return {
      showNav: undefined
    }
  },
  computed: {
    links () {
      return this.$t('variables.footerLinks')
    },
    getMetaList () {
      return this.$t('variables.metaList')
    }
  },
  created () {
    console.log('핑크퐁 카탈로그 페이지에 오신것을 환영합니다.')
    window.addEventListener('touchstart', this.contentScrolled)
    this.$store.commit('initFilterParams')
    const oldLang = this.$store.getters.getLanguage
    const newLang = this.$route.path.split('/')[1]
    if (oldLang) {
      if (oldLang !== newLang) {
        this.$store.commit('clearItem')
        this.$store.commit('initLanguage', newLang)
      }
    } else {
      this.$store.commit('initLanguage', newLang)
    }
  },
  destroyed () {
    window.removeEventListener('touchstart', this.contentScrolled)
  },
  beforeMount () {
    if (screen.width < 1264) {
      this.showNav = false
    }
  },
  methods: {
    contentScrolled (e) {
      if (this.showNav && e.targetTouches[0].target.classList[0] === 'v-overlay') {
        this.$eventBus.$emit('hideNav')
      }
    },
    getFooterMarginLeft () {
      if (screen.width < 1264) {
        return '0px'
      } else {
        if (this.showNav) return '300px'
        return '0px'
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  #app-top-nav .v-toolbar__content {
    height: 56px !important;
  }
  #app-content {
    padding-top: 56px !important;
  }

  .footer-title {
    text-transform: none !important;
  }

  /* vue-mulitiselect - 셀렉트 박스 전역 커스텀 css */
  .multiselect span{
    font-size: 14px !important;
  }

  .multiselect span{
    font-size: 14px !important;
  }

  .multiselect .multiselect__tags{
    padding-top: 0px !important;
    padding-right: 23px !important;
    border-radius: 0px !important;
    border-color: #5A5A5A !important;
    color: black !important;

    display: flex;
    align-items: center;
  }

  .multiselect .multiselect__single{
    margin-bottom: 0px;
    padding-left: 0px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }

  .multiselect .multiselect__select{
    padding: 0px;
    width: 23px;
    color: black;
  }

  .multiselect .multiselect__placeholder{
    margin-bottom: 0px;
    color: black;
  }

  .multiselect__option--selected{
    background: #5f5f59;
    color: white;
    font-weight: normal;
  }

  .multiselect__option--highlight{
    /* background-color: #b2b4b4;
    color: white !important;
    font-weight: bold !important; */
  }

  .swal2-shown{
    padding: 0px !important;
  }

  .multiselect__option{
    background: white !important;
    color: black !important;
    font-weight: bold !important;
  }
  .multiselect__option.multiselect__option--highlight{
    background: white !important;
    color: black !important;
    box-sizing: border-box;
    border: 2px solid rgb(255 103 175);
    font-weight: bold !important;
  }

  .multiselect__option--selected.multiselect__option--highlight{
    background: rgb(255 103 175) !important;
    color: white !important;
    box-sizing: border-box;
    border: 2px solid white;
    font-weight: bold !important;
  }
  .multiselect__option--selected{
    background: rgb(255 103 175) !important;
    color: white !important;
    font-weight: bold !important;
  }

  .multiselect__content-wrapper {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    width: unset;
    min-width: 100%;
  }

  button {
    box-shadow: none !important;
  }

  .v-btn-toggle {
    box-shadow: none !important;
    border: 1px solid rgb(234, 234, 234) !important;
  }

  .card-body, .v-card {
    box-shadow: none !important;
    border: 1px solid rgb(234, 234, 234) !important;
  }

  .v-toolbar.v-toolbar--fixed.theme--light {
    box-shadow: none !important;
    border-bottom: 1px solid rgb(234, 234, 234) !important;
  }

  .v-menu__content {
    box-shadow: none !important;
    border: 1px solid rgb(234, 234, 234);
  }

  #app-sidebar .v-input__slot {
    box-shadow: none !important;
    border: 1px solid rgb(234, 234, 234) !important;
  }

  #add-to-cart-btn{
    background-color: rgb(255 104 175);
  }

  .hover-pointer:hover{
    cursor: pointer !important;
  }

  .hover-pointer:hover *{
    cursor: pointer !important;
  }

  .multiselect:hover {
    cursor: pointer !important;
  }

  .vue-treeselect:hover {
    cursor: pointer !important;
  }

  .quantity-field .v-text-field__details{
    overflow: visible !important;
  }

  .quantity-field .v-messages__message{
    width: 300px !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue